module.exports = __webpack_public_path__ + "img/2.18d1abd7.jpg";